import { ThemeOptions } from '@mui/material';

// Note that List is used internally by Menu (through MenuList)
export const MuiList: ThemeOptions['components']['MuiList'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiDivider-root': {
        borderColor: theme.palette.divider,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    })
  }
};
